import { Component, OnInit } from "@angular/core";
import { EntityExData } from "common";
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { ActivatedRoute, Router } from "@angular/router";

@UntilDestroy()
@Component({
    selector: "ifp-entity-select",
    templateUrl: "./entity-select.component.html",
    standalone: false
})
export class EntitySelectComponent implements OnInit {
  entities: EntityExData[];
  currentEntityId: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  ngOnInit() {
    this.route.data.pipe(untilDestroyed(this)).subscribe((data) => {
      this.entities = data?.entities;
      this.currentEntityId = data?.entity?.id;
    });
  }

  changeEntity(entityId: number): void {
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { companyId: entityId },
      queryParamsHandling: "merge",
    });
  }
}
